import React from "react";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import * as THREE from "three";

export interface ObjectState {
    object: THREE.Object3D;
}

const initialState: ObjectState = {
    object: new THREE.Object3D(),
};

export const objectSlice = createSlice({
    name: "object",
    initialState,
    reducers: {
        setObject: (state, action: PayloadAction<THREE.Object3D>) => {
            state.object = action.payload;
        },
    },
});

export const { setObject } = objectSlice.actions;

export const selectObject = (state: RootState) => state.object.object;

export default objectSlice.reducer;
